export function generateRandomString(length: number): string {
  const array = new Uint8Array(Math.ceil(length / 2))
  crypto.getRandomValues(array) // Fill the array with secure random bytes
  return Array.from(array)
    .map(byte => byte.toString(16).padStart(2, "0")) // Convert to hexadecimal and ensure two characters
    .join("")
    .slice(0, length) // Take the desired length
}
